import React, { forwardRef, useImperativeHandle } from 'react'
import { isEmpty } from 'lodash'
import { useForm, Controller } from 'react-hook-form'
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Link,
  Typography,
} from '@material-ui/core'

import { LoadingFeedback } from 'components'

import useRegulations from 'hooks/useRegulations'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

import schema from './schema'
import theme from 'theme'

const RegulationAcceptanceForm = forwardRef((_props, ref) => {
  const snackbar = useSnackbar()

  const { regulationVersions, isLoading, tokenRaw } = useRegulations()

  const { control, errors, triggerValidation } = useForm({
    validationSchema: schema,
  })

  const validate = async () => await triggerValidation()

  const accept = async () => {
    if (isEmpty(regulationVersions)) return

    try {
      const regulationVersionIds = regulationVersions?.map(
        (regulationVersion) => regulationVersion?.id,
      )

      await service.dponet.public.regulationVersions.accept({
        regulationVersionAcceptance: { regulationVersionIds },
        tokenRaw,
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro ao aceitar os termos, caso o problema persista entre em contato com o suporte!',
        variant: 'error',
      })
    }
  }

  useImperativeHandle(ref, () => ({ validate, accept }))

  return (
    <Box display="flex" flexDirection="column" gap={theme.spacing(2)}>
      <LoadingFeedback open={isLoading} />
      {regulationVersions?.map((regulationVersion) => {
        const fieldName = `acceptance-${regulationVersion?.id}`

        return (
          <Box key={regulationVersion?.id}>
            <FormControlLabel
              control={
                <Controller
                  name={fieldName}
                  control={control}
                  type="checkbox"
                  defaultValue={false}
                  as={<Checkbox color="primary" />}
                />
              }
              label={
                <Typography>
                  Li e concordo com{' '}
                  <Typography
                    component={Link}
                    href={regulationVersion?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {regulationVersion?.regulation?.title}
                  </Typography>
                </Typography>
              }
            />
            {!!errors?.[fieldName] && (
              <FormHelperText error>
                {errors?.[fieldName]?.message}
              </FormHelperText>
            )}
          </Box>
        )
      })}
    </Box>
  )
})

RegulationAcceptanceForm.displayName = 'RegulationAcceptanceForm'

export default RegulationAcceptanceForm
